//物资模块接口设置
/* eslint-disable */
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams,
} from "@/api/request"; // 导入request中创建的axios实例

//物资模块接口设置
const material = {
  vehicleManage: {
    //车辆管理模块
    save: (mode, params) => {
      return mode == "add" ?
        postRequest("app/materialCar/addMaterialCar", params) :
        postRequest("app/materialCar/updateMaterialCarInfo", params);
    },
    info: (vehicleId) => {
      //车辆详情接口-肖东
      return getRequest("app/materialCar/carDetails/" + vehicleId, {});
    },
    deleteVehicle: (vehicleId) => {
      //车辆信息删除接口-肖东
      return postRequest("app/materialCar/deletedMaterialCar/" + vehicleId, {});
    },
  },
  vehicleApply: {
    //车辆申请模块
    carDetails: (applyId) => {
      //车辆详情接口-肖东
      return getRequest("app/materialCar/carDetails/" + applyId, {});
    },
    //用车申请添加接口-肖东|申请编辑接口-肖东
    addEditUseCar: (mode, params) => {
      if (mode == "add") {
        return postRequestParams("app/applyUseCar/addApplyUseCar", params); //用车申请添加接口-肖东
      } else {
        return postRequest("app/applyUseCar/updateApplyUseCar", params); //申请编辑接口-肖东
      }
    },
    //用车申请详情接口-肖东
    detailsUseCar: (id) => {
      return getRequest("app/applyUseCar/details/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //申请删除接口-肖东|申请撤回接口-肖东
      return mode == "hold" ?
        postRequest("app/applyUseCar/deletedApplyUsecar/" + id, {}) //申请删除接口-肖东
        :
        postRequest("app/applyUseCar/changVerifyStatus/" + id, {}); //申请撤回接口-肖东
    },
    //车辆出库
    dispatchCar: (params) => { 
      return postRequest("app/materialCar/affirmUseCar", params); //确认用车接口-陈国贵
    },

    //车辆归还操作
    returnCar: (params) => {
      return postRequest("app/materialCar/addBackCarInfo", params); //归还信息填报接口-陈国贵
    },
  },

  // 采购申请管理
  procurementManage: {
    deleteRecall: (mode, id) => {
      //采购申请删除接口-肖东|采购申请撤回接口-肖东
      return mode == "hold" ?
        postRequest("app/applyPurchase/deleted/" + id, {}) //采购申请删除接口-肖东
        :
        postRequest("app/applyPurchase/changVerifyStatus/" + id, {}); //采购申请撤回接口-肖东
    },
    //新增采购申请接口-肖东|采购申请编辑接口-肖东
    addEditProcurement: (mode, params) => {
      if (mode == "add") {
        return postRequest("app/applyPurchase/add", params); //新增采购申请接口-肖东
      } else {
        return postRequest("app/applyPurchase/update", params); //采购申请编辑接口-肖东
      }
    },
    //采购申请详情接口-肖东
    detailsProcurement: (id) => {
      return getRequest("app/applyPurchase/details/" + id, {});
    },
    //资产登记筛选列表接口-肖东
    materialRegisterList: (id) => {
      return getRequest("app/applyPurchase/materialRegisterList/" + id, {});
    },
  },

  //印章申请
  sealApply: {
    //有效章列表
    validSealList: () => {
      return getRequest("/app/applyOfficeSeal/validList");
    },

    //撤回申请
    backApply: (id) => {
      return postRequest("/app/applyOfficeSeal/recall/" + id, {});
    },

    addEditApply: (mode, params) => {
      return mode == "add" ?
        postRequest("app/applyOfficeSeal/addApplyOfficeSeal", params) :
        postRequest("app/applyOfficeSeal/updateApply", params);
    },
    //删除申请
    deleteApply: (id) => {
      return postRequest("app/applyOfficeSeal/deletedApply/" + id, {});
    },
    //重新提交申请
    resubmission: (id) => {
      return postRequest("app/applyOfficeSeal/againCommit/" + id, {});
    },
    //印章申请信息详情的数据带入
    detailsSeal: (id) => {
      return getRequest("app/applyOfficeSeal/details/" + id, {});
    },
  },
  //物资管理
  materialManage: {
    /*新增&编辑*/
    save: (mode, params) => {
      return mode == "add" ?
        postRequest("app/materialReserve/add", params) :
        postRequest("app/materialReserve/update", params);
    },
    /*获取详情*/
    details: (id) => {
      return getRequest("app/materialReserve/details/" + id, {});
    },
    /*删除*/
    delete: (id) => {
      return postRequest("app/materialReserve/deleted" + "?id=" + id, {});
    },
  },
  //物资申领
  materialApply: {
    deleteRecall: (mode, id) => {
      //物资申领-删除接口-肖东|物资申领-撤回接口-肖东
      return mode == "hold" ?
        postRequest("app/getMaterial/deleteApplyGetMaterial/" + id, {}) //物资申领-删除接口-肖东
        :
        postRequest("app/getMaterial/applyGetMaterialRecall/" + id, {}); //物资申领-撤回接口-肖东
    },
    //物资申领-新增接口-肖东|物资申领-编辑接口-肖东
    addEditProcurement: (mode, params) => {
      if (mode == "add") {
        return postRequest("app/getMaterial/addApplyGetMaterial", params); //物资申领-新增接口-肖东
      } else {
        return postRequest("app/getMaterial/updateApplyGetMaterial", params); //物资申领-编辑接口-肖东
      }
    },
    //查询物资领用详情信息接口-肖东
    detailsProcurement: (id) => {
      return getRequest("app/getMaterial/detailsWeb/" + id, {});
    },
    //查询物资详情接口-肖东
    detailsMaterial: (id) => {
      return getRequest("app/materialReserve/details/" + id, {});
    },
    getProjectMaterialAmount: (params) => {
      return getRequest("app/getMaterial/projectMaterialAmount", params);
    },
  },
  //物资申领归还
  materialApplyBack: {
    //新增获取详情接口
    detailsmaterialApply: (id) => { //查询物资领用详情信息接口-肖东
      return getRequest("/app/getMaterial/detailsWeb/" + id, {});
    },

    //物资归还详情编辑接口
    detailsmaterialApplyBack: (id) => {
      return getRequest("apply/returnMaterial/details/" + id, {});
    },

    //添加申请归还
    addMaterialApplyBack: (mode, params) => {
      return mode == "add" ?
        postRequest("apply/returnMaterial/addApplyReturnMaterial", params) :
        postRequest("apply/returnMaterial/updateApplyReturnMaterial", params);
    },
    //编辑归还
    // editMaterialApplyBack: (params) => {
    //   return postRequest(
    //     "apply/returnMaterial/updateApplyReturnMaterial",
    //     params
    //   );
    // },
    //删除，撤回归还申请
    backBackApply: (mode, id) => {
      return mode == "hold" ?
        postRequest("apply/returnMaterial/deleteApplyReturnMaterial/" + id, {}) //删除归还申请
        :
        postRequest("apply/returnMaterial/applyReturnMaterialRecall/" + id, {}); //撤回归还申请
    },


    // backBackApply: (id) => {
    //   return postRequest(
    //     "apply/returnMaterial/applyReturnMaterialRecall/" + id,
    //     {}
    //   );
    // },
    // //删除归还申请
    // deleteBackApply: (id) => {
    //   return postRequest(
    //     "apply/returnMaterial/deleteApplyReturnMaterial/" + id,
    //     {}
    //   );
    // },
    //重新提交归还申请
    resubmissionBackApply: (id) => {
      return postRequest(
        "apply/returnMaterial/againCommitApplyReturnMaterial/" + id, {}
      );
    },
  },
};

export default material;